/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReRateModel } from './ReRateModel';
import {
    ReRateModelFromJSON,
    ReRateModelFromJSONTyped,
    ReRateModelToJSON,
    ReRateModelToJSONTyped,
} from './ReRateModel';

/**
 * 
 * @export
 * @interface ReRateServiceGetResponse
 */
export interface ReRateServiceGetResponse {
    /**
     * 
     * @type {Array<ReRateModel>}
     * @memberof ReRateServiceGetResponse
     */
    reRates?: Array<ReRateModel> | null;
}

/**
 * Check if a given object implements the ReRateServiceGetResponse interface.
 */
export function instanceOfReRateServiceGetResponse(value: object): value is ReRateServiceGetResponse {
    return true;
}

export function ReRateServiceGetResponseFromJSON(json: any): ReRateServiceGetResponse {
    return ReRateServiceGetResponseFromJSONTyped(json, false);
}

export function ReRateServiceGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReRateServiceGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reRates': json['reRates'] == null ? undefined : ((json['reRates'] as Array<any>).map(ReRateModelFromJSON)),
    };
}

export function ReRateServiceGetResponseToJSON(json: any): ReRateServiceGetResponse {
    return ReRateServiceGetResponseToJSONTyped(json, false);
}

export function ReRateServiceGetResponseToJSONTyped(value?: ReRateServiceGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reRates': value['reRates'] == null ? undefined : ((value['reRates'] as Array<any>).map(ReRateModelToJSON)),
    };
}

